export enum ActionType {
	ContestCreated = "ContestCreated",
	ContestsIndexRetrieved = "ContestsIndexRetrieved",
	ContestSummaryRetrieved = "ContestSummaryRetrieved",
	ContestImagesFetched = "ContestImagesFetched",
	ContestPatched = "ContestPatched",

	ContestPlayersRetrieved = "ContestPlayersRetrieved",

	GamesRetrieved = "GamesRetrieved",

	ContestSessionsRetrieved = "ContestSessionsRetrieved",
	SessionPatched = "SessionPatched",

	RiggingTokenAcquired = "RiggingTokenAcquired",
	LoggedOut = "LoggedOut",

	TeamCreated = "TeamCreated",
	TeamPatched = "TeamPatched",
	TeamDeleted = "TeamDeleted",
}
